import PageHero from "@/components/layout/PageHero";
import { Mail, MapPin, Phone, ArrowUpRight } from "lucide-react";
import { IMAGES } from "@/lib/constants";
import ContactForm from "@/components/sections/ContactForm";

const CHANNELS = [
    { icon: Mail, label: "General Enquiries", value: "info@carbonis.in", href: "mailto:info@carbonis.in" },
    { icon: Phone, label: "Direct Line", value: "+91 95157 27578", href: "tel:+919515727578" }
];

const OFFICES = [
    { city: "Hyderabad", role: "Headquarters", addr: "India · Institutional & Engineering" }
];

export default function ContactPage() {
    return (
        <div data-testid="page-contact">
            <PageHero
                title={<>Speak with a <em className="text-gold not-italic font-light">Carbonis strategist.</em></>}
                lead="Institutional briefings, MSME onboarding pilots, and framework mapping sessions — routed within one business day."
                image={IMAGES.hero}
            />

            <section className="relative py-24 lg:py-32 border-t border-navy/10">
                <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
                        <div className="lg:col-span-5">
                            <div className="flex items-center gap-4 mb-6">
                                <div className="w-10 h-px bg-gold"></div>
                                <span className="font-mono text-[11px] tracking-[0.28em] uppercase text-gold">Reach Us</span>
                            </div>
                            <h2 className="font-serif text-4xl md:text-5xl leading-[1.02] tracking-[-0.02em] mb-8">
                                Direct lines. <em className="text-gold not-italic font-light">Or a form.</em>
                            </h2>
                            <p className="text-navy/60 text-lg leading-relaxed max-w-[440px]">
                                We prefer conversations. Reach out on any channel — a senior strategist responds personally, not a bot.
                            </p>
                        </div>

                        <div className="lg:col-span-7">
                            <div className="border border-navy/10">
                                {CHANNELS.map((c, i) => {
                                    const Icon = c.icon;
                                    return (
                                        <a
                                            key={i}
                                            href={c.href}
                                            data-testid={`contact-channel-${i}`}
                                            className="group grid grid-cols-12 items-center gap-6 py-6 px-6 lg:px-10 border-b border-navy/10 last:border-b-0 hover:bg-white/60 transition-colors duration-500"
                                        >
                                            <div className="col-span-1">
                                                <Icon size={18} strokeWidth={1.4} className="text-gold" />
                                            </div>
                                            <div className="col-span-4">
                                                <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-navy/40">{c.label}</div>
                                            </div>
                                            <div className="col-span-6">
                                                <div className="font-serif text-2xl text-navy group-hover:text-gold transition-colors duration-500">{c.value}</div>
                                            </div>
                                            <div className="col-span-1 flex justify-end">
                                                <ArrowUpRight size={18} strokeWidth={1.4} className="text-navy/40 group-hover:text-gold group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-500" />
                                            </div>
                                        </a>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    <div className="mt-16">
                        <ContactForm />
                    </div>
                </div>
            </section>

            <section className="relative py-24 lg:py-32 border-t border-navy/10">
                <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
                    <div className="flex items-center gap-4 mb-16">
                        <div className="w-10 h-px bg-gold"></div>
                        <span className="font-mono text-[11px] tracking-[0.28em] uppercase text-gold">Offices</span>
                    </div>
                    <div className="max-w-[520px]">
                        {OFFICES.map((o, i) => (
                            <div key={i} className="bg-white border border-navy/10 p-10 min-h-[220px] flex flex-col justify-between" data-testid={`office-${i}`}>
                                <MapPin size={20} strokeWidth={1.2} className="text-gold" />
                                <div>
                                    <div className="font-serif text-4xl text-navy mb-2">{o.city}</div>
                                    <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-navy/50 mb-3">{o.role}</div>
                                    <div className="text-navy/60 text-sm">{o.addr}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
